import React, { createContext, useState } from 'react';

import SearchTimeData from './SearchTimeData';

export const SearchTimeStateContext = createContext();

const SearchTimeContextProvider = ({ children }) => {
  const stateHook = useState(SearchTimeData.INITIAL_STATE);

  return (
    <SearchTimeStateContext.Provider value={stateHook}>
      {children}
    </SearchTimeStateContext.Provider>
  );
};

export default SearchTimeContextProvider;